import React from "react";
import { motion } from "framer-motion";
import "./AboutUs.css";

const AboutUs = () => {
  return (
    <section className="about-us">
      <div className="hero-banner">
        <img
          src="https://images.unsplash.com/photo-1556761175-5973dc0f32e7?auto=format&fit=crop&w=1200&q=80"
          alt="About Us"
          className="banner-image"
        />
        <div className="hero-text">
          <h1>About CLYRA Overseas</h1>
          <p>Shaping Futures, Empowering Global Education Journeys</p>
        </div>
      </div>

      <div className="container">
        <motion.div className="content-block" initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{ duration: 0.8 }}>
          <h2>Who We Are</h2>
          <p>
            CLYRA Overseas is a leading abroad education consultancy, trusted by thousands of students. We provide expert advice, streamlined application processes, and end-to-end support to help students realize their dream of studying abroad.
          </p>
        </motion.div>

        <motion.div className="content-block" initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{ duration: 0.8, delay: 0.2 }}>
          <h2>Our Mission</h2>
          <p>
            Our mission is to empower students with global opportunities by offering transparent guidance, trusted partnerships, and lifelong learning support. We aim to simplify the complexities of international education through ethical and personalized counseling.
          </p>
        </motion.div>

        <motion.div className="content-block" initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{ duration: 0.8, delay: 0.4 }}>
          <h2>Our Services</h2>
          <ul>
            <li>University & Course Selection</li>
            <li>Application & Documentation Assistance</li>
            <li>Language Coaching (IELTS, TOEFL, GRE, PTE)</li>
            <li>Visa Counseling & Interview Preparation</li>
            <li>Pre-Departure Briefings</li>
            <li>Post-Arrival Support</li>
            <li>Scholarship & Financial Aid Guidance</li>
          </ul>
        </motion.div>

        <motion.div className="image-banner" initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{ duration: 0.8, delay: 0.6 }}>
        
        </motion.div>

        <motion.div className="content-block" initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{ duration: 0.8, delay: 0.7 }}>
          <h2>Why Choose CLYRA Overseas?</h2>
          <ul>
            <li>Experienced counselors with 10+ years of expertise</li>
            <li>Direct partnerships with top-ranked global universities</li>
            <li>High success rates in university admissions & visas</li>
            <li>Ethical, transparent, and student-focused approach</li>
            <li>Global alumni network and career guidance</li>
          </ul>
        </motion.div>

        <motion.div className="content-block" initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{ duration: 0.8, delay: 0.8 }}>
          <h2>Global Destinations We Serve</h2>
          <p>We help students study in:</p>
          <ul className="destinations">
            <li>United States</li>
            <li>Canada</li>
            <li>United Kingdom</li>
            <li>Australia</li>
            <li>Germany</li>
            <li>New Zealand</li>
            <li>France</li>
            <li>Ireland</li>
          </ul>
        </motion.div>

        
      </div>
    </section>
  );
};

export default AboutUs;
